const initialState = {
  loading: false,
  error: null,
  message: null,
  landingPageDetails: null,
  landingPagePlanDetails: null,
  landingPageBannerDetails: null,
  lmsProductStatus: null,
};

const LandingReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_LANDING_PAGE_DETAIL_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_LANDING_DETAIL_SUCCESS":
      return {
        ...state,
        loading: false,
        landingPageDetails: action.payload,
      };
    case "GET_LANDING_DETAIL_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case "GET_LANDING_DETAIL_PLAN_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_LANDING_DETAIL_PLAN_SUCCESS":
      return {
        ...state,
        loading: false,
        landingPagePlanDetails: action.payload,
      };
    case "GET_LANDING_DETAIL_PLAN_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case "GET_LANDING_PAGE_BANNER_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_LANDING_PAGE_BANNER_SUCCESS":
      return {
        ...state,
        loading: false,
        landingPageBannerDetails: action.payload,
      };
    case "GET_LANDING_PAGE_BANNER_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case "POST_LMS_PRODUCT_STATUS_SUCCESS":
      return {
        ...state,
        loading: false,
        lmsProductStatus: action.payload,
      };
    case "POST_LMS_PRODUCT_STATUS_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case "POST_LMS_REGISTER_SUCCESS":
      return {
        ...state,
        loading: false,
        lmsProductStatus: action.payload,
      };
    case "POST_LMS_REGISTER_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default LandingReducer;
